import React from "react";
import "./loader.scss";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loadingspinner"></div>
      <div className="loader-message">Loading... Please wait.</div>
    </div>
  );
};

export default Loader;
